/**
 * Syncs Ingredient Preview (HW) with the active ingredient tab panel.
 *
 * @see blocks/_hw-loop-preview__ingredient.liquid
 * @see snippets/hw-loop-ingredient-tab.liquid
 */
(function () {
  'use strict';

  /**
   * @param {HTMLElement} previewRoot
   * @param {HTMLElement} tabEl
   */
  function applyTabPreview(previewRoot, tabEl) {
    const template = tabEl.querySelector(
      'template[data-hw-ingredient-preview-tab-data]'
    );
    if (!template) return;

    const countEl = template.content.querySelector(
      '[data-hw-ingredient-preview-count]'
    );
    const imagesEl = template.content.querySelector(
      '[data-hw-ingredient-preview-images]'
    );
    const count = countEl ? countEl.textContent.trim() : '0';

    const imagesTarget = previewRoot.querySelector(
      '.hw-ingredient-preview__images'
    );
    if (imagesTarget && imagesEl) {
      imagesTarget.innerHTML = imagesEl.innerHTML;
    }

    const textEl = previewRoot.querySelector(
      '[data-hw-ingredient-preview-text]'
    );
    const textTemplate = previewRoot.getAttribute('data-text-template');
    if (textEl && textTemplate) {
      textEl.textContent = textTemplate.replace('{count}', count);
    }
  }

  /**
   * @param {HTMLElement} sectionRoot
   */
  function wireIngredientPreview(sectionRoot, attempt = 0) {
    const previews = sectionRoot.querySelectorAll(
      '[data-hw-ingredient-preview-sync]'
    );
    if (!previews.length) return;

    const hwTabs = sectionRoot.querySelector('hw-tabs');
    if (!hwTabs) {
      if (attempt < 30) {
        requestAnimationFrame(() => {
          wireIngredientPreview(sectionRoot, attempt + 1);
        });
      }
      return;
    }

    /**
     * @param {number} index
     */
    const sync = (index) => {
      const tabs = hwTabs.querySelectorAll(':scope > hw-tab');
      const tabEl = tabs[index];
      if (!tabEl) return;
      previews.forEach((previewRoot) => {
        applyTabPreview(previewRoot, tabEl);
      });
    };

    if (hwTabs.getAttribute('data-hw-ingredient-preview-wired') === 'true') {
      return;
    }
    hwTabs.setAttribute('data-hw-ingredient-preview-wired', 'true');

    hwTabs.addEventListener('hw-tabs:activate', (event) => {
      const idx =
        event.detail && typeof event.detail.index === 'number'
          ? event.detail.index
          : 0;
      sync(idx);
    });

    const tryInitialSync = () => {
      if (hwTabs.hasAttribute('data-hw-ready')) {
        sync(0);
        return;
      }
      requestAnimationFrame(tryInitialSync);
    };

    tryInitialSync();
  }

  function initAll() {
    document
      .querySelectorAll('[data-hw-tabbed-carousel]')
      .forEach((sectionRoot) => {
        wireIngredientPreview(sectionRoot);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const sectionRoot = event.target;
    if (!sectionRoot || !sectionRoot.querySelector) return;

    const carouselRoot = sectionRoot.querySelector('[data-hw-tabbed-carousel]');
    if (!carouselRoot) return;

    wireIngredientPreview(carouselRoot);
  });
})();
